import React, { Component } from 'react'
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";

@inject("registrationStore")
@observer
export default class RedirectToStep extends Component {
  constructor(props) {
    super(props)
    this.props.registrationStore.setSession(this.props.session);
  }

  render() {
    return (
      <Redirect to={"/registration/step_" + Math.floor(this.props.registrationStore.status)} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationStepsRoute/RedirectToStep.js